<template>
    <b-button v-if="id" :size="size ? size : 'sm'" v-on:click="confirmDelete()" :variant="variant ? variant : 'danger'">
        <i class="fa fa-times" v-if="!hideIcon" aria-hidden="true"></i> {{!hideText ? this.$i18n.t('buttons.verwijderen') : ''}}
    </b-button>
</template>
<script>
export default {
    name:'controls-delete',
    props: ['size','variant','hideIcon','hideText','noRedirect','title','id','entityId','namespace','resource'],
    methods: {
        confirmDelete() {
            var vm = this;
            vm.$swal ({
                title: `${vm.title} ${this.$i18n.t('delete.verwijderen')}`,
                text: `${this.$i18n.t('delete.weetuzekerdatudeze')} ${vm.title.toLowerCase()} ${this.$i18n.t('delete.wiltverwijderen')}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: this.$i18n.t('delete.javerwijderen'),
                cancelButtonText: this.$i18n.t('delete.neeannuleren')
            })
            .then((result) => {
                var i18n = this.$i18n;
                if (result.value) {
                    var payload = {
                        resource: vm.resource, 
                        entityId: vm.entityId,
                        id: vm.id
                    };
                    vm.$store.dispatch(`${vm.namespace}/delete`,payload)
                    .then(() => {
                        vm.$swal(i18n.t('delete.succesvol'), `${i18n.t('delete.de')} ${vm.title.toLowerCase()} ${i18n.t('delete.isverwijderd')}`, "success");   
                        if(!vm.noRedirect) {
                            vm.$router.push({ name: `${vm.resource}:index` });
                        }
                    })
                    .catch(() => {
                        vm.$swal(i18n.t('delete.mislukt'), `${i18n.t('delete.de')} ${vm.title.toLowerCase()} ${i18n.t('delete.konnietwordenverwijderd')}`, "error");
                    });
                }
            })
        }
    }
}
</script>